var cov_gltw1icol = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageResult.tsx",
      hash = "979945cb85c6b94dca9f437266490017fcb874a3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageResult.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 28
        },
        end: {
          line: 12,
          column: 29
        }
      },
      "2": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 16
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 52
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 46
        }
      },
      "7": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 54
        }
      },
      "8": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 66
        }
      },
      "9": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "10": {
        start: {
          line: 33,
          column: 40
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "11": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 36
        }
      },
      "12": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 22
        }
      },
      "13": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 66
        }
      },
      "14": {
        start: {
          line: 42,
          column: 29
        },
        end: {
          line: 42,
          column: 66
        }
      },
      "15": {
        start: {
          line: 46,
          column: 40
        },
        end: {
          line: 46,
          column: 50
        }
      },
      "16": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "17": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 29
        }
      },
      "18": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 30
        }
      },
      "19": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 27
        }
      },
      "20": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 57,
          column: 27
        }
      },
      "21": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 24
        }
      },
      "22": {
        start: {
          line: 62,
          column: 90
        },
        end: {
          line: 62,
          column: 100
        }
      },
      "23": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "24": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 64,
          column: 37
        }
      },
      "25": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 67,
          column: 8
        }
      },
      "26": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 37
        }
      },
      "27": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 12
        }
      },
      "28": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 18
        }
      },
      "29": {
        start: {
          line: 74,
          column: 30
        },
        end: {
          line: 74,
          column: 40
        }
      },
      "30": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 34
        }
      },
      "31": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "32": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 110,
          column: 18
        }
      },
      "33": {
        start: {
          line: 111,
          column: 22
        },
        end: {
          line: 111,
          column: 94
        }
      },
      "34": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 35
        }
      },
      "35": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 139,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 17
          }
        },
        loc: {
          start: {
            line: 12,
            column: 28
          },
          end: {
            line: 12,
            column: 29
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 45
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 17
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 41
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 18
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 45
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 40
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 52
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 56
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 18
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 61
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 66,
            column: 17
          },
          end: {
            line: 66,
            column: 18
          }
        },
        loc: {
          start: {
            line: 66,
            column: 23
          },
          end: {
            line: 66,
            column: 37
          }
        },
        line: 66
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 18
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 73
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 11
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 100
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 19
          }
        }, {
          start: {
            line: 34,
            column: 23
          },
          end: {
            line: 34,
            column: 36
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 66
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 66
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 47
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 27
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 27
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 23
          },
          end: {
            line: 62,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 62,
            column: 38
          },
          end: {
            line: 62,
            column: 63
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 63
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 51
          },
          end: {
            line: 77,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 51
          },
          end: {
            line: 77,
            column: 58
          }
        }, {
          start: {
            line: 77,
            column: 62
          },
          end: {
            line: 77,
            column: 76
          }
        }],
        line: 77
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 9
          },
          end: {
            line: 95,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 9
          },
          end: {
            line: 83,
            column: 28
          }
        }, {
          start: {
            line: 84,
            column: 10
          },
          end: {
            line: 94,
            column: 14
          }
        }],
        line: 83
      },
      "8": {
        loc: {
          start: {
            line: 86,
            column: 21
          },
          end: {
            line: 86,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 37
          },
          end: {
            line: 86,
            column: 46
          }
        }, {
          start: {
            line: 86,
            column: 49
          },
          end: {
            line: 86,
            column: 66
          }
        }],
        line: 86
      },
      "9": {
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 103,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 103,
            column: 21
          },
          end: {
            line: 103,
            column: 46
          }
        }],
        line: 103
      },
      "10": {
        loc: {
          start: {
            line: 111,
            column: 64
          },
          end: {
            line: 111,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 64
          },
          end: {
            line: 111,
            column: 75
          }
        }, {
          start: {
            line: 111,
            column: 79
          },
          end: {
            line: 111,
            column: 93
          }
        }],
        line: 111
      },
      "11": {
        loc: {
          start: {
            line: 116,
            column: 9
          },
          end: {
            line: 129,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 9
          },
          end: {
            line: 116,
            column: 12
          }
        }, {
          start: {
            line: 117,
            column: 11
          },
          end: {
            line: 129,
            column: 11
          }
        }],
        line: 116
      },
      "12": {
        loc: {
          start: {
            line: 117,
            column: 11
          },
          end: {
            line: 129,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 52
          }
        }, {
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 128,
            column: 14
          }
        }],
        line: 117
      },
      "13": {
        loc: {
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 135,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 131,
            column: 20
          }
        }, {
          start: {
            line: 132,
            column: 10
          },
          end: {
            line: 134,
            column: 14
          }
        }],
        line: 131
      },
      "14": {
        loc: {
          start: {
            line: 136,
            column: 9
          },
          end: {
            line: 136,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 9
          },
          end: {
            line: 136,
            column: 24
          }
        }, {
          start: {
            line: 136,
            column: 28
          },
          end: {
            line: 136,
            column: 98
          }
        }],
        line: 136
      },
      "15": {
        loc: {
          start: {
            line: 137,
            column: 9
          },
          end: {
            line: 137,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 9
          },
          end: {
            line: 137,
            column: 23
          }
        }, {
          start: {
            line: 137,
            column: 27
          },
          end: {
            line: 137,
            column: 47
          }
        }],
        line: 137
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/ImageResult.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import Image from '../Image';
import RemoveConfirm from './RemoveConfirm';
import { uploadClass } from './styles';
var DefaultProps = (cov_gltw1icol.s[0]++, {
  renderResult: function renderResult(a) {
    cov_gltw1icol.f[0]++;
    cov_gltw1icol.s[1]++;
    return a;
  }
});

var ImageResult =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageResult, _PureComponent);

  var _super = _createSuper2(ImageResult);

  function ImageResult(props) {
    var _this;

    _classCallCheck(this, ImageResult);

    cov_gltw1icol.f[1]++;
    cov_gltw1icol.s[2]++;
    _this = _super.call(this, props);
    _this.image = void 0;
    cov_gltw1icol.s[3]++;
    _this.state = {
      confirm: false
    };
    cov_gltw1icol.s[4]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    cov_gltw1icol.s[5]++;
    _this.handleRecover = _this.handleRecover.bind(_assertThisInitialized(_this));
    cov_gltw1icol.s[6]++;
    _this.bindImage = _this.bindImage.bind(_assertThisInitialized(_this));
    cov_gltw1icol.s[7]++;
    _this.handlePreview = _this.handlePreview.bind(_assertThisInitialized(_this));
    cov_gltw1icol.s[8]++;
    _this.handleConfirmChange = _this.handleConfirmChange.bind(_assertThisInitialized(_this));
    cov_gltw1icol.s[9]++;
    _this.preview = _this.preview.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ImageResult, [{
    key: "bindImage",
    value: function bindImage(image) {
      cov_gltw1icol.f[3]++;
      cov_gltw1icol.s[12]++;
      this.image = image;
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      cov_gltw1icol.f[4]++;
      cov_gltw1icol.s[13]++;

      if (this.props.onRemove) {
        cov_gltw1icol.b[1][0]++;
        cov_gltw1icol.s[14]++;
        this.props.onRemove(this.props.index);
      } else {
        cov_gltw1icol.b[1][1]++;
      }
    }
  }, {
    key: "handleRecover",
    value: function handleRecover() {
      cov_gltw1icol.f[5]++;

      var _ref = (cov_gltw1icol.s[15]++, this.props),
          onRecover = _ref.onRecover,
          value = _ref.value,
          index = _ref.index;

      cov_gltw1icol.s[16]++;

      if (onRecover) {
        cov_gltw1icol.b[2][0]++;
        cov_gltw1icol.s[17]++;
        onRecover(index, value);
      } else {
        cov_gltw1icol.b[2][1]++;
      }
    }
  }, {
    key: "handleConfirmChange",
    value: function handleConfirmChange(confirm) {
      cov_gltw1icol.f[6]++;
      cov_gltw1icol.s[18]++;
      this.setState({
        confirm: confirm
      });
    }
  }, {
    key: "preview",
    value: function preview() {
      cov_gltw1icol.f[7]++;
      cov_gltw1icol.s[19]++;

      if (!this.image) {
        cov_gltw1icol.b[3][0]++;
        cov_gltw1icol.s[20]++;
        return;
      } else {
        cov_gltw1icol.b[3][1]++;
      }

      cov_gltw1icol.s[21]++;
      this.image.preview();
    }
  }, {
    key: "handlePreview",
    value: function handlePreview() {
      var _this2 = this;

      cov_gltw1icol.f[8]++;

      var _ref2 = (cov_gltw1icol.s[22]++, this.props),
          onPreview = _ref2.onPreview,
          _ref2$renderResult = _ref2.renderResult,
          renderResult = _ref2$renderResult === void 0 ? (cov_gltw1icol.b[4][0]++, DefaultProps.renderResult) : _ref2$renderResult,
          value = _ref2.value,
          index = _ref2.index,
          values = _ref2.values;

      cov_gltw1icol.s[23]++;

      if (onPreview) {
        cov_gltw1icol.b[5][0]++;
        var url = (cov_gltw1icol.s[24]++, renderResult(value));
        cov_gltw1icol.s[25]++;
        onPreview(url, value, index, values, {
          preview: function preview() {
            cov_gltw1icol.f[9]++;
            cov_gltw1icol.s[26]++;
            return _this2.preview();
          }
        });
        cov_gltw1icol.s[27]++;
        return;
      } else {
        cov_gltw1icol.b[5][1]++;
      }

      cov_gltw1icol.s[28]++;
      this.preview();
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      cov_gltw1icol.f[10]++;

      var _ref3 = (cov_gltw1icol.s[29]++, this.props),
          removeConfirm = _ref3.removeConfirm;

      var _ref4 = (cov_gltw1icol.s[30]++, this.state),
          confirm = _ref4.confirm;

      cov_gltw1icol.s[31]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('image-options', (cov_gltw1icol.b[6][0]++, confirm) && (cov_gltw1icol.b[6][1]++, 'image-active')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 77,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('options-item'),
          onClick: this.handlePreview,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79,
            columnNumber: 11
          }
        }, icons.Preview), (cov_gltw1icol.b[7][0]++, this.props.onRemove) && (cov_gltw1icol.b[7][1]++,
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('options-item', 'options-remove'),
          onClick: removeConfirm ? (cov_gltw1icol.b[8][0]++, undefined) : (cov_gltw1icol.b[8][1]++, this.handleRemove),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 84,
            columnNumber: 11
          }
        }, icons.Delete,
        /*#__PURE__*/
        React.createElement(RemoveConfirm, {
          onVisibleChange: this.handleConfirmChange,
          onRemove: this.handleRemove,
          confirm: removeConfirm,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 89,
            columnNumber: 13
          }
        }))))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_gltw1icol.f[11]++;

      var _ref5 = (cov_gltw1icol.s[32]++, this.props),
          value = _ref5.value,
          _ref5$renderResult = _ref5.renderResult,
          renderResult = _ref5$renderResult === void 0 ? (cov_gltw1icol.b[9][0]++, DefaultProps.renderResult) : _ref5$renderResult,
          recoverAble = _ref5.recoverAble,
          renderContent = _ref5.renderContent,
          style = _ref5.style,
          showRecover = _ref5.showRecover,
          index = _ref5.index,
          values = _ref5.values;

      var className = (cov_gltw1icol.s[33]++, uploadClass('image-item', 'image-result', (cov_gltw1icol.b[10][0]++, recoverAble) && (cov_gltw1icol.b[10][1]++, 'to-be-delete')));
      var url = (cov_gltw1icol.s[34]++, renderResult(value));
      cov_gltw1icol.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 115,
            columnNumber: 7
          }
        }, (cov_gltw1icol.b[11][0]++, url) && (cov_gltw1icol.b[11][1]++, renderContent ? (cov_gltw1icol.b[12][0]++, renderContent(url, value, index, values)) : (cov_gltw1icol.b[12][1]++,
        /*#__PURE__*/
        React.createElement(Image, {
          ref: this.bindImage,
          src: url,
          href: url,
          fit: "center",
          width: "auto",
          height: 0,
          className: uploadClass('image-bg'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120,
            columnNumber: 13
          }
        }))), (cov_gltw1icol.b[13][0]++, showRecover) && (cov_gltw1icol.b[13][1]++,
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('recover'),
          onClick: this.handleRecover,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132,
            columnNumber: 11
          }
        }, icons.Recovery)), (cov_gltw1icol.b[14][0]++, this.showRemove) && (cov_gltw1icol.b[14][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: uploadClass('delete'),
          onClick: this.handleRemove,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 136,
            columnNumber: 29
          }
        })), (cov_gltw1icol.b[15][0]++, !renderContent) && (cov_gltw1icol.b[15][1]++, this.renderOptions()))
      );
    }
  }, {
    key: "showRemove",
    get: function get() {
      cov_gltw1icol.f[2]++;

      var _ref6 = (cov_gltw1icol.s[10]++, this.props),
          onRemove = _ref6.onRemove,
          renderContent = _ref6.renderContent;

      cov_gltw1icol.s[11]++;
      return (cov_gltw1icol.b[0][0]++, onRemove) && (cov_gltw1icol.b[0][1]++, renderContent);
    }
  }]);

  return ImageResult;
}(PureComponent);

ImageResult.defaultProps = DefaultProps;
export default ImageResult;